/* eslint-disable react/jsx-pascal-case */
import React, { Fragment } from "react";
import Nx_Grid from "./nx_grid";
import Nx_Table from "./nx_table";
import Nx_Filters from "./filters/nx_filters";
import "./nx_grid.scss";
import Grid from "../ui_components/layouts/Grid/Grid";

class Nx_Grid_Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      fields: this.props.gridProps?.fields,
      mobileFields: this.props.gridMobileProps?.fields,
      activeFilters: {},
      lastUpdate: 0,
      isMobile: window.innerWidth < 820,
    };
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 820 });
  };

  shouldComponentUpdate = (nextProps) => {
    if (
      this.props.gridProps.fields.length != nextProps.gridProps.fields.length
    ) {
      this.setState({
        fields: nextProps.gridProps.fields,
        mobileFields: nextProps.gridMobileProps.fields,
      });
    }
    return true;
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    const { isMobile } = this.state;
    return (
      <Fragment>
        <Grid className="uf_content_main">
          <Grid
            className={"uf_content_main_container"}
            style={{
              width: "100%",
              height: "auto",
              gridAutoFlow: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Nx_Filters
              table={this.props.table}
              onFiltersChange={(activeFilters) =>
                this.setState({
                  activeFilters,
                  lastUpdate: new Date().getTime(),
                })
              }
              renderCustomFilters={this.props.renderCustomFilters}
              initialSearch={this.props.initialSearch}
            />
            <Grid
              style={
                !isMobile ? { textAlign: "right" } : { textAlign: "center" }
              }
            >
              {this.props.renderTools()}
            </Grid>
            {isMobile && this.props.renderProfileAdditional ? (
              <Grid>{this.props.renderProfileAdditional()}</Grid>
            ) : null}
          </Grid>
          {this.props.tableType === "table" ? (
            <Nx_Table
              rowHeight={this.props.rowHeight}
              table={this.props.table}
              additional_data={this.props.additional_data}
              filters={this.state.activeFilters}
              onDataItemsLoad={this.props.onDataItemsLoad}
              syncData={this.props.syncData}
              attendeeType={this.props.attendeeType}
              customFiltering={this.props.customFiltering}
              registrationType={this.props.registrationType}
              id={this.props.id}
              onEdit={this.props.onEdit}
              onDelete={this.props.onDelete}
              showTotals={this.props.showTotals}
              lastUpdate={
                this.props.lastUpdate > this.state.lastUpdate
                  ? this.props.lastUpdate
                  : this.state.lastUpdate
              }
              handleParentFetchData={this.props.handleParentFetchData}
              fetchData={this.props.fetchData}
              buttons={this.props.buttons}
              popOverButtons={this.props.popOverButtons}
              rowDoubleClick={this.props.rowDoubleClick}
              onRowClick={this.props.onRowClick}
              onAdd={this.props.onAdd}
              row={this.props.rows}
              fields={this.state.fields}
              mobileFields={this.state.mobileFields}
              expandableRows={this.props.expandableRows}
              checkboxSelection={this.props.checkboxSelection}
              handleSelectionModelChange={this.props.handleSelectionModelChange}
              handleExpadableRowChange={this.props.handleExpadableRowChange}
              expandableRowData={this.props.expandableRowData}
            />
          ) : (
            <Nx_Grid
              rowHeight={this.props.rowHeight}
              showTotals={this.props.showTotals}
              table={this.props.table}
              additional_data={this.props.additional_data}
              filters={this.state.activeFilters}
              onDataItemsLoad={this.props.onDataItemsLoad}
              syncData={this.props.syncData}
              attendeeType={this.props.attendeeType}
              customFiltering={this.props.customFiltering}
              registrationType={this.props.registrationType}
              id={this.props.id}
              onEdit={this.props.onEdit}
              onDelete={this.props.onDelete}
              lastUpdate={
                this.props.lastUpdate > this.state.lastUpdate
                  ? this.props.lastUpdate
                  : this.state.lastUpdate
              }
              fetchData={this.props.fetchData}
              buttons={this.props.buttons}
              popOverButtons={this.props.popOverButtons}
              rowDoubleClick={this.props.rowDoubleClick}
              onRowClick={this.props.onRowClick}
              onAdd={this.props.onAdd}
              fields={this.props.gridProps.fields}
              mobileFields={this.state.mobileFields}
              expandableRows={this.props.expandableRows}
              checkboxSelection={this.props.checkboxSelection}
              handleSelectionModelChange={this.props.handleSelectionModelChange}
            />
          )}
        </Grid>
      </Fragment>
    );
  }
}

export default Nx_Grid_Filters;
